import { filterFeaturesBasedOncurrentProject } from "@lib/_common/util";
import { SURVEY_FEATURES } from "@lib/_common/util/surveyFeatures";
import {
  scrollToFirstRequiredQuestion,
  submitCheckAndSaveWork,
  submitSaveWork,
} from "@lib/_common/util/surveyUtil";
import { TSurveyFeature } from "@lib/_common/util/types";
import { addStyles } from "@lib/setupRoot";
import { For, Show, createSignal, onMount } from "solid-js";
import floatingActionBarStyles from "./FloatingActionBar.css?inline";

export function FloatingActionBar() {
  const [isCurrentlyFilling, setIsCurrentlyFilling] = createSignal(false);

  const surveyFeatures = filterFeaturesBasedOncurrentProject(SURVEY_FEATURES);

  async function handleFeatureClick(feature: TSurveyFeature) {
    console.log(`Feature clicked: ${feature.featureName}`);

    setIsCurrentlyFilling(true);
    await feature.callback();
    setIsCurrentlyFilling(false);
  }

  onMount(() => {
    addStyles(floatingActionBarStyles);
    console.log("Mounting Floating App Action Bar");
  });

  return (
    <div id="mm-actions">
      <h1 id="mm-actions-header">Quick Actions</h1>
      <div
        id="mm-action-status-info"
        classList={{
          "visually-hidden": !isCurrentlyFilling(),
        }}
      >
        Filling...
      </div>
      <button class="mm-btn" onclick={submitSaveWork} style="background: #888f95">
        Save Work
      </button>
      <button class="mm-btn" onclick={submitCheckAndSaveWork} style="background: #888f95">
        Check Answers and Save
      </button>
      <hr style="width: 100%;" />
      <button class="mm-btn" onclick={scrollToFirstRequiredQuestion} style="background: #db4747d4;">
        Find * Required warnings
      </button>

      <Show when={surveyFeatures.length !== 0}>
        <hr style="width: 100%;" />
        <For each={surveyFeatures}>
          {(feature) => (
            <button class="mm-btn" onclick={() => handleFeatureClick(feature)}>
              {feature.featureName}
            </button>
          )}
        </For>
      </Show>
    </div>
  );
}
